<template>
  <swiper-slide class="swiper_newpage4">
  </swiper-slide>
</template>
  <script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "newpage4",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
    };
  },
};
</script>
  <style lang="less" scoped>
.swiper_newpage4{
    width: 100% !important;
  height: 100%;
  background: url("../assets/newpagebg4.jpg") no-repeat;
  background-size: 100% 100%;
}
</style>